export const focusTrap = (
    container: HTMLElement,
): void => {
    container.addEventListener("keydown", (event: KeyboardEvent) => {
        if (
            event.key === "Tab" &&
            container?.getAttribute("aria-expanded") === "true"
        ) {
            const focusableElements = container.querySelectorAll<HTMLElement>(
                'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
            );

            if (!focusableElements || focusableElements.length === 0) return;

            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement =
                focusableElements[focusableElements.length - 1];

            if (
                event.shiftKey &&
                document.activeElement === firstFocusableElement
            ) {
                event.preventDefault();
                lastFocusableElement.focus();
            } else if (
                !event.shiftKey &&
                document.activeElement === lastFocusableElement
            ) {
                event.preventDefault();
                firstFocusableElement.focus();
            }
        }
    });
};
